import React from 'react';
// @ts-expect-error type-lazyLoader
import { getLazyLoaderRenderFunction, lazyLoader } from '@/lib';
import { LoadingSpinnerFromIndexFile } from '../App/LoadingSpinnerFromIndexFile';

export const LazyLanding = lazyLoader({
  /*
    DO NOT ALTER 'webpackChunkName: 'landing' COMMENT
    Adding this comment will cause our separate chunk 
    to be named [my-chunk-name].{HASH}.js instead of [id].js.
    WHY? -  custom preload
  */
  loader: () => import(/* webpackChunkName: 'landing' */ './Landing'),
  loading: () => <LoadingSpinnerFromIndexFile />,
  name: 'Landing',
  render: getLazyLoaderRenderFunction({
    componentName: 'Landing',
  }),
});
